import React from 'react';

const withMaskedInput = (inputName) => (WrappedComponent) => {
  class HOC extends React.Component {
    constructor(props) {
      super(props);

      this.lastSelection = this.props[inputName].length || 0;
  
      this.onClick = this.onClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }
    onClick(event) {
      // Set the cursor position to the last typed character when clicking in input
      let selection = event.target.selectionEnd;
  
      if(selection > this.lastSelection) {
        event.target.setSelectionRange(this.lastSelection, this.lastSelection);
      }
    }  
    beforeMaskedValueChange = (newState, oldState, userInput) => {
      var { value } = newState;
      var selection = newState.selection;
      
      // Set last selection to the lest entered character
      this.lastSelection = value.replace(/[_-]/g, ' ').trimEnd().length;
  
      return {
        value,
        selection
      };
    }
    onKeyDown(event) {
      // Prevent entering _ chracters or using right arrow key to got to the end of the input if nothing has been entered in it yet.
      if(event.key === "_" || event.key === " " || event.key === "-") {
        event.preventDefault();
      }
      else if(event.key === "ArrowRight") {
        let selection = event.target.selectionEnd;
        
        if(selection >= this.lastSelection) {
          event.preventDefault();
        }
      }
      else if(event.key === "ArrowDown") {
        event.preventDefault();
        event.target.setSelectionRange(this.lastSelection, this.lastSelection);
      }
    } 
    render() {
      return (
        <WrappedComponent
          onClick={this.onClick}
          beforeMaskedValueChange={this.beforeMaskedValueChange}
          onKeyDown={this.onKeyDown}
          {...this.props}
        />
      );
    }
  }
    
  return HOC; 
}

export default withMaskedInput;


// WEBPACK FOOTER //
// ./src/HOC/withMaskedInput.js